import resolve from 'ioc/resolve'
//import config from 'emun.auth/users/_config'
//import ServiceBus from 'servicestack/service-bus'

class User {
    constructor(dto) {
        let m = this;
        //m.bus = new ServiceBus();

        //properties
        m.id = null; //int
        m.euid = null; //'guid'
        Object.assign(m, dto);
        if(m.phoneNumber && !m.phone) m.phone = m.phoneNumber;
        if(m.zip && !m.zip) m.zip = m.zip;
        delete m.phoneNumber;
        if(m.phoneNumber && !m.phone) m.phone = m.phoneNumber;
        delete m.roles;
        if (!m.meta) m.meta = {};
    }

    load() { }

    save() { }
}

export default User